import { render, staticRenderFns } from "./microSuper.vue?vue&type=template&id=417dcacc&"
import script from "./microSuper.vue?vue&type=script&lang=js&"
export * from "./microSuper.vue?vue&type=script&lang=js&"
import style0 from "./microSuper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports